module.exports = __webpack_public_path__ + "img/roof-repair-exterior-maintenance-06-xxlarge.6918e6f0.jpg";